/** R + Ziffern wie scan.ts / getLagerForRow; nur das Platzcode-Präfix auswerten. */
export function reiheAusLeerplatzMeldung(message: string): string | null {
  return /^(R\d+)\+F/.exec(message)?.[1] ?? null
}
